import Bugsnag, { Client as BugsnagClient } from '@bugsnag/js'

declare global {
  interface Window {
    bugsnagClient: BugsnagClient
    PM_BUGSNAG_CONFIG?: {
      apiKey: string
      appType: string
      releaseStage: string
      collectUserIp: boolean
      user: {
        id?: string
        name?: string
        email?: string
      }
      metadata?: {
        account_id?: string
      }
    }
  }
}

function initBugsnagClient() {
  if (!window.PM_BUGSNAG_CONFIG) {
    console.error('missing PM_BUGSNAG_CONFIG')
    return
  }

  window.bugsnagClient = Bugsnag.start(window.PM_BUGSNAG_CONFIG)
}
initBugsnagClient()
